import $thousandMask from "@/mixins/thousandMask";
import makeSecure from "@/components/MakeSecure";
import { mapActions } from "vuex";
import * as types from "@/store/types";
import { WalletService } from "@/services";
import debounce from "lodash-es/debounce";
export default {
  name: "profit-or-loses-amount-in-table",
  components: { makeSecure },
  mixins: [$thousandMask],
  props: [],
  data() {
    return {
      checkWalletLoading: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    ...mapActions({
      updateCheckWallets: types.wallets.actions.UPDATE_CHECK_WALLETS,
      setNewWallets: types.wallets.actions.SET_NEW_WALLETS
    }),
    updateWalletID(id) {
      this.checkWalletLoading = true;
      this.callUpdateWalletID(id);
    },
    callUpdateWalletID: debounce(function(id) {
      WalletService.updateWalletV4(id)
        .then(response => {
          this.updateCheckWallets({
            id: id,
            show_update: false
          });
          this.$toast.success(response.data.message);
          WalletService.getWalletV2().then(res => {
            this.setNewWallets(res.data.data.wallets);
            setTimeout(() => {
              this.updateCheckWallets({
                id: id,
                show_update: true
              });
            }, response.data.data.user_check_wallet_interval);
          });
        })
        .catch(error => {
          this.$toast.error(error.data.message);
          if (error.status) {
            this.checkWalletLoading = false;
          }
        })
        .finally(() => {
          this.checkWalletLoading = false;
        });
    }, 2000)
  }
};
